module.exports = "/_next/static/images/d53050de29f42b4aee140fdc75edfc4d-nu-card-md@2x.jpg";